import { ReactNode } from "react";

import { ArrowCircleRightOutlined, VideoLibrary } from "@mui/icons-material";
import { Card, CardActions, CardMedia, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LOCAL_STORAGE_KEYS } from "../../constants";
import { useEventLog, useLocalStorage } from "../../hooks";
import { TFileType } from "../../models";
import useUiStore from "../../stores/useUiStore";
import { getCardTypeFromPath } from "../../utils";

type TOwnProps = {
  id: string;
  title: string;
  cardImg?: string;
  path: string;
  channelPath: string;
};

const ChannelCard = (props: TOwnProps) => {
  const { title, id, cardImg, path, channelPath } = props;
  const { logChannel } = useEventLog();
  const navigate = useNavigate();
  const { isDesktop } = useUiStore();
  const { configures } = useLocalStorage();

  const noImagePath = "/assets/images/offlineThumbnail.png";
  const extenstion = getCardTypeFromPath(path);

  const detailIconMappers: Record<TFileType, ReactNode> = {
    channel: <ArrowCircleRightOutlined />,
    video: <VideoLibrary />,
    image: <ArrowCircleRightOutlined />,
  };

  return (
    <Card
      onClick={() => {
        const sessionId =
          localStorage.getItem(LOCAL_STORAGE_KEYS.SESSIONS_ID) || "no-session";

        if (extenstion !== "video") {
          logChannel({
            sessionId: sessionId,
            kisokId: configures?.id || 0,
            communityId: configures?.communityConfiguration.communityId || 0,
            communityName:
              configures?.communityConfiguration.community.name || "n/a",
            communityConfigurationName:
              configures?.communityConfiguration.name || "n/a",
            channelPath: channelPath,
            hostName: configures?.hostName || "LOH-K-00000000",
          });
        }

        navigate(path);
      }}
      sx={(theme) => ({
        width: "100%",
        height: "100%",
        cursor: "pointer",
      })}
    >
      <CardMedia
        sx={{
          objectFit: isDesktop ? "contain" : "cover",
          width: "100%",
          height: {
            xs: 200,
            md: 250,
            lg: 270,
          },
        }}
        component="img"
        image={cardImg || noImagePath}
        id={`${id}-thumbnail`}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = noImagePath;
        }}
      />

      <CardActions
        sx={{
          height: 30,
          display: "flex",
          justifyContent: "center",
          cursor: "pointer",
          backgroundColor: "#7C0612",
          "& svg": {
            color: "white",
            position: "absolute",
            right: "1rem",
          },
        }}
      >
        <Typography variant="h5" noWrap color="white" width="70%">
          {title}
        </Typography>
        {detailIconMappers[extenstion]}
      </CardActions>
    </Card>
  );
};

export default ChannelCard;
